<template>
    <div>
        <card-header title='New Survey Question' icon="fa-plus"/>

        <card-body>
            <rmc-question-form :question="newQuestion"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!newQuestion.type || !newQuestion.title"
                    ><i class="fas fa-plus mr-2"></i>New Survey Question</b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardFooter from "@/TIER/components/CardFooter";
    import RmcQuestionForm from "./QuestionForm";

    import {client as http} from "@/http_client";

    export default {
        components: {RmcQuestionForm, CardHeader, CardBody, CardFooter},
        props: ['card', 'props'],
        data() {
            return {
                newQuestion: {
                    options: []
                }
            }
        },
        methods: {
            submit: function() {
                this.$emit('loading', true);
                http.post('rmc/sessions/' + this.props.sessionId + '/survey', {session_id: this.props.sessionId, ...this.newQuestion}, {force: true}).then(response => {
                    this.$reloadCard('rmc-session-survey-questions', {sessionId: this.props.sessionId});
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the question.');
                    this.$emit('loading', false);
                });
            }
        }
    }
</script>
